import { useState } from 'react';
import { getAuth, signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { useString } from "providers/LocalisationProvider";

export default function FirebaseSignInUI() {
    const [error, setError] = useState(null);
    const signInWithGoogleString = useString('sign_in_with_google');

    const signInWithGoogle = async () => {
        setError(null);
        try {
            await signInWithPopup(getAuth(), new GoogleAuthProvider());
        } catch (e) {
            // The user closing the popup is a normal cancellation, not an error.
            if (e.code === 'auth/popup-closed-by-user' || e.code === 'auth/cancelled-popup-request') {
                return;
            }
            setError(e.message);
        }
    };

    return (
        <>
            <button
                type="button"
                className="sign-in-button primary-button rounded"
                onClick={signInWithGoogle}
            >
                {signInWithGoogleString}
            </button>
            {error && <p className="text-danger">{error}</p>}
        </>
    );
}
